// extracted by mini-css-extract-plugin
export var compactFilters = "_eq-4";
export var detailImage = "_eq-1";
export var dropdownContainer = "_eq-2";
export var imageContainer = "_eq-0";
export var selectedCard = "_eq-3";